import React, { useEffect } from 'react'
import { Route, useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'

import { APP_ROUTES } from '../../constants'
import { useLoggedInUser } from '../../hooks'

const GuestRoute = ({ component: Component, ...rest }) => {
  const user = useLoggedInUser()
  const history = useHistory()

  useEffect(() => {
    if (user) {
      history.push(APP_ROUTES.INGREDIENTS.link)
    }
  }, [history, user])

  return <Route {...rest} component={Component} />
}

GuestRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
}

export default GuestRoute
